import { Button } from "primereact/button";
import React, { FC } from 'react';
import { tawreedTranslationService } from "../../../../common/translations";
import { GlobalContext } from "../../../../context";
import { AuthUtils } from "../../../auth/domain";
import { TawreedTable, TawreedTableProps } from "../../../../common";
import { Dialog } from "primereact/dialog";
import { CssUtils } from "../../../../helpers/css";
import { TawreedTableFormatters } from "../../../../common/components/table/formatters";
import { TawreedAction, TawreedActionName } from "../../../../common/actions";
import { PrimeIcons } from "primereact/api";
import { DashboardService } from "../../domain";
import { TawreedTableFilters } from "../../../../common/components/table/filters";

export interface SalesByCategoryDialogProps {
    hide: () => void;
    xlsxReportURI?: string;
    // pdfReportURI: string;
    visible:boolean;
    data:any
}

export const SalesByCategoryDialog: FC<SalesByCategoryDialogProps> = ({ visible, hide, xlsxReportURI, data}) => {

    
    const FinancePartnerDialogFooter = () => {
        return <div>
            <Button label={tawreedTranslationService.translate('lbl_cancel')} icon="pi pi-times" onClick={hide} className="p-button-text" disabled={false} />

        </div>;
    }
    const FinancePartnerDialogHeader = () => {
        return <div>
            <p>{tawreedTranslationService.translate("lbl_orderdashboard_orders_by_category")}</p>
        </div>
    }
    const { auth: { user }, constants: { constants } } = React.useContext(GlobalContext);

    const lang = AuthUtils.current().language;

    const tawreed: TawreedTableProps = {
        header: false,
        disableGlobalSearch: false,
        pagination: true,
        dataKey: '',
        name: '',
        title: '',
        ds: {
            mode: 'basic',
            data: data
        },
        columns: [
            {
                dataType: 'text',
                field: "store",
                header: "lbl_sales_orders_store",
                sortable: true,
                filter: true,
                style: CssUtils.width('10%'),
            },
            {
                dataType: 'text',
                field: "category",
                header: "lbl_category",
                sortable: true,
                filter: true,
                style: CssUtils.width('10%'),
            },
            {
                dataType: 'numeric',
                field: "value",
                header: "lbl_total",
                sortable: true,
                filter: true,
                style: CssUtils.width('15%', CssUtils.color('var(--danger-color)')),
            }
        ],
        toolbar: {
            // actions: data && data?.length > 0 ? [

            //     new TawreedAction(TawreedActionName.ReportsExport, 'stateless', 'lbl_reports_export_as_excel', PrimeIcons.FILE_EXCEL, () => print(xlsxReportURI!)),
            // ] :
             actions: [],
        },
        filter: {
            filterDisplay: 'menu',
            initial: {
                store: {
                    operator: 'AND',
                    constraints: [
                        {
                            value:  undefined,
                            matchMode: 'contains',
                        }
                    ]
                },
                category: {
                    operator: 'AND',
                    constraints: [
                        {
                            value:  undefined,
                            matchMode: 'contains',
                        }
                    ]
                },
               value:
               {
                operator: 'AND',
                    constraints: [
                        {
                            value:  undefined,
                            matchMode: 'equals',
                        }
                    ]
               }
            }
        },
        sort: {
            sortMode: 'single',
            initial: {
                sortField: 'orderId',
                sortOrder: 1,
                multiSortMeta: undefined,
            },
        },

    }

    return (

        <Dialog maximizable resizable style={{ minWidth: '80%' }}
            header={<FinancePartnerDialogHeader />}
            visible={visible} footer={<FinancePartnerDialogFooter />} onHide={hide} draggable={false}
            position="top" closable={true} closeOnEscape={true}>
            <TawreedTable  {...tawreed} />
        </Dialog>
    )
}
